import React from "react";
import { X, Download } from "lucide-react";

const ImageViewModal = ({ imageUrl, onClose }) => {
  if (!imageUrl) return null;

  return (
    <div className="fixed inset-0 z-[10000] bg-black/80 backdrop-blur-sm flex items-center justify-center p-4">
      <div className="relative max-w-4xl max-h-[90vh] flex flex-col items-center">
        <button
          onClick={onClose}
          className="absolute -top-10 right-0 p-2 text-white/80 hover:text-white transition-colors"
        >
          <X className="w-6 h-6" />
        </button>

        <img
          src={imageUrl}
          alt="Enlarged preview"
          className="max-w-full max-h-[80vh] rounded-xl object-contain shadow-2xl"
        />

        <div className="mt-4 flex items-center gap-3">
          <a
            href={imageUrl}
            download="activity_image.png"
            className="flex items-center gap-1.5 px-4 py-2 rounded-lg bg-white/10 hover:bg-white/20 text-white font-medium text-xs backdrop-blur transition-all"
          >
            <Download className="w-4 h-4" />
            <span>Download Image</span>
          </a>
        </div>
      </div>
    </div>
  );
};

export default ImageViewModal;
